/**
 * Labstep
 *
 * @module components/OrderRequest/Action/Create/Bulk
 * @desc Bulk Create Action for order request
 */

import { CanCreate } from 'labstep-web/components/Entity/Can';
import { OrderRequestFormCreateBulk } from 'labstep-web/components/OrderRequest/Form/Create/Bulk';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentBulk as BulkActionComponent } from 'labstep-web/core/Action/Component/Bulk';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { enhanceOptions } from 'labstep-web/services/utils.service';
import type React from 'react';
import type { OrderRequestActionCreateBulkProps } from './types';

export const OrderRequestActionCreateBulk: React.FC<
  OrderRequestActionCreateBulkProps
> = ({ entities, options }) => {
  return (
    <CanCreate entityName="order_request">
      <ModalDefault
        header="Request"
        content={({ toggleModal }) => (
          <OrderRequestFormCreateBulk
            resources={entities}
            options={enhanceOptions({
              options,
              onSuccess: toggleModal,
            })}
          />
        )}
        viewComponent={({ toggleModal }) => (
          <BulkActionComponent
            entitiesWithPermissionCount={entities.length}
            entitiesSelectedCount={entities.length}
            onClick={toggleModal}
            content="Request"
            icon={ICONS.order_request.primary}
          />
        )}
      />
    </CanCreate>
  );
};
